import ls from "local-storage";

export default {
    data() {
        return {
            tourCallbacks: {
                onStop: this.handleTour,
                onFinish: this.handleTour,
                onSkip: this.handleTour
            },
            tourOptions: {
                highlight: true,
                labels: {
                    buttonSkip: this.$t('pages.settings.marketplace_settings.tour.buttonSkip'),
                    buttonPrevious: this.$t('pages.settings.marketplace_settings.tour.buttonPrevious'),
                    buttonNext: this.$t('pages.settings.marketplace_settings.tour.buttonNext'),
                    buttonStop: this.$t('pages.settings.marketplace_settings.tour.buttonStop')
                }
            },
            steps: [
                {
                    target: '.v-step1',
                    content: this.$t('pages.settings.marketplace_settings.tour.step1'),
                    before: async () => {
                        await this.$bvModal.hide('connect-marketplace-modal')
                    }
                },
                {
                    target: '.v-step2',
                    content: this.$t('pages.settings.marketplace_settings.tour.step2'),
                    before: () => new Promise(async (resolve) => {
                        await this.$bvModal.show('connect-marketplace-modal')
                        setTimeout(() => {
                            resolve()
                        }, 300)
                    })
                },
                {
                    target: '.v-step3',
                    content: this.$t('pages.settings.marketplace_settings.tour.step3'),
                },
                {
                    target: '.v-step4',
                    content: this.$t('pages.settings.marketplace_settings.tour.step4'),
                },
            ]
        }
    },
    methods: {
        handleTour() {
            ls.remove('userJustArrived')
        },
        handleMarketplaceTour() {
            if (ls.get('userJustArrived')) {
                if (this.$route.query?.tab === 'marketplaces') {
                    this.$tours['marketplaceTour'].start()
                } else {
                    this.$watch('$route.query', function (newVal) {
                        if (newVal?.tab === 'marketplaces')
                            this.$tours['marketplaceTour'].start()
                    })
                }
            }
        }
    }
}